<template>
  <div>
      <div class="box">
        <BInputText
          label-text="班级名称"
          v-model="searchParam.trainClassName"
          :maxLength="20"
          placeholder="班级名称"
        />
        <BBtnSecondary
          :img-src="require('@/assets/icon_screen.png')"
          :clicked="doSearch"
          hidden-key="true"
          btn-txt="筛选"
          style="margin-left: 30px;"
        />
      </div>
      <div class="search-result">
            <div class="search-functions-headers">
                <div class="search-functions">
                    <BBtnPrimary
                      :img-src="require('@/assets/new.png')"
                      :clicked="doClassAdd"
                      hidden-key=""
                      btn-txt="添加班级"
                    />
                </div>
                <div class="search-result-summary">
                    <div class="summary">
                      班级：{{classNum}}
                    </div>
                    <div class="summary">
                      总学员：{{studentTotalNum}}人
                    </div>
                </div>
            </div>
            <Table
              :headers="headers"
              :tableData="classList"
              :length="totalPages"
              :total-visible="7"
              :page-num="page"
              v-model="page"
              @input="doSearch(false)"
            >
              <template v-slot:actions="item">
                  <div style="display:flex;flex-direction:row;justify-content: left;margin-left:10px;">
                    <div
                      class="btn-detail"
                      @click="handleEdit(item.data)"
                    >
                      详情
                    </div>
                    <div
                      class="btn-delete"
                      @click="handleDelete(item.data)"
                    >
                      删除
                    </div>
                    <div
                      v-if="item.data.signInName !== '--' && item.data.status!=='01'" 
                      class="btn-signIn"
                      @click="goSignIn(item.data)"
                    >
                      签到
                    </div>
                    <div v-else class="btn-signIn">
                      ----
                    </div>
                  </div>
              </template>
            </Table>
      </div>
  </div>
</template>
<script>
import { searchInit, searchList, deletes,getSignList} from "@/api/classManagement";
import BInputText from "../../components2/BInputText";
import Table from "../../components2/Table";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Hub from '../../events/Hub';
import PopupContents from "../../views2/sample/PopupContents";
import SignSelect from "@/views2/sample/SignSelect";
import Vue from "vue";

  export default {
    name: 'CourseManagement',
    components: {
      Table,
      BInputText,
      BBtnPrimary,
      BBtnSecondary,
    },
    data: () => ({
      totalPages: 0,
      page: 1,
      limit: 10,
      totalCount: 0,
      headers: [
        { text: 'ID', value: 'indexNum', align: 'center', width:'5%' },
        { text: '班级名称', value: 'trainClassName', width:'10%', align:'center' },
        { text: '负责老师', value: 'trainTeacherName', width:'8%', align:'center' },
        { text: '期间', value: 'classTime', width:'15%', align:'center' },
        { text: '状态', value: 'statusName', width:'6%', align:'center' },
        { text: '课程名称', value: 'trainCourseName', width:'10%', align:'center' },
        { text: '签到设置', value: 'signInName', width:'20%', align:'center' },
        { text: '学员数量', value: 'studentNum', align:'center', width:'8%' },
        { text: '操作', value: 'actions', align: 'center',width:'14%', },
      ],
      searchParam: {
        trainClassName: '',
      },
      classList:[],
      addDialog: false,
      classDetail: {
        classTeacherId: '',
        trainClassName: '',
      },
      classTeacherList:[],
      dialogTitle: '',
      deleteDialog:false,
      deleteSuccess:false,
      updateSuccess:false,
      classNum: '',
      studentTotalNum: '',
      totalCounts: '',
      deleteId: '',
      obj: {},
      data: {},
      userRoleType: '',
      navi: [
        {name: "class-management"},
      ],
      signList:{
        checked: '',
        data: [],
      },
      signNum:null,
    }),
    created () {
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(sessionStorage.getItem('store')),
          ),
        )
        sessionStorage.removeItem('store')
      }
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      })
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        // 判断是否是从菜单跳至此页面
        const isClear = vm.comUtils.checkUrl(from.name)
        // 如果是从菜单跳过来的 就 清除查询条件
        if (isClear === 'true') {
          vm.$store.commit('REMOVE_TRAIN_CLASS_PARAMS')
          vm.$store.commit('SET_TRAIN_CLASS_PARAMS', 1)
        }
        // 查询条件赋值
        // if (vm.$store.state.classManagement_trainClassName !== undefined) {
        //   vm.searchParam.trainMajorId =
        //     vm.$store.state.classManagement_trainClassName
        // }
      
        vm.searchInit()
      })
    },
    beforeMount() {
      this.$store.commit('SET_NAVI_DATA', this.navi);
    },
    methods: {
      async searchInit(){
        var param = {
          id: null,
        }
        const data = await searchInit(param);
        this.userRoleType = data.data.userRoleType
        this.searchList()
      },
      doSearch (flag) {
        if (flag) {
          this.totalPages = 0
          this.page = 1
          this.limit = 10
          this.totalCounts = 0
        }
        this.searchList()
      },
      async searchList(){
        var param = {
          trainClassName: this.comUtils.trim(this.searchParam.trainClassName),
          page: this.page,
          limit: this.limit,
        }
        const data = await searchList(param)
        this.classList = data.data.searchList
        this.classNum = data.data.totalCounts
        this.studentTotalNum = data.data.studentTotalNum
        this.totalCounts = data.data.totalCounts
        this.totalPages = Math.ceil(this.totalCounts / this.limit)
      },
      handleDelete (item) {
        if(item.studentNum>0){
          this.data.bodyText = '将同步删除该班级下所有学员信息,确认是否删除？'
          this.deleteId = item.id
          Hub.$emit('open-modal');
          Hub.$emit('set-modal-data', this.data.bodyText, '删除', PopupContents);
        }else{
          this.data.bodyText = '确认是否删除？'
          this.deleteId = item.id
          Hub.$emit('open-modal');
          Hub.$emit('set-modal-data', this.data.bodyText, '删除', PopupContents);
        }
      },
      async deleteOne () {
        var param = {
          id: this.deleteId
        }
        const data = await deletes(param)
        if (data.code == 0) {
          Vue.prototype.$vsnackbar.show(data.msg);
          this.deleteId = ''
          this.doSearch(true)
        } else {
          Vue.prototype.$valertbar.show(data.msg);
        }
      },
      async doClassAdd(){
          this.$router.push({
            name: "class-management-add",
          });
      },
      async handleEdit(item){
        // 下拉初始化
        this.$router.push({
            name: "class-management-public",
            params:{classId:item.id,status:item.status,courseId:item.courseId},
          });
      },
      // 详情
      async handleInfo(item){
        this.$router.push({
            name: "class-management-course",
            params:{classId:item.id},
          });
      },
      
      
      // 学员
      goToStudent (data) {
        this.$router.push({
          name: "student-management",
          params: { classId: data.id ,status:data.status},
        })
      },
      async goSignIn(item){
        var param = {
          id: item.id
        }
        const data  = await getSignList(param)
        this.signNum = data.data.signList.length
        let signDataList = data.data.signList
        let signDatas = []
        for (let i = 0; i < signDataList.length; i++) {
          let signData = {
            id: signDataList[i].value,
            name: 'radio',
            label: signDataList[i].text,
            value: signDataList[i].value,
          }
          signDatas.push(signData)
        }
        this.signList.data = signDatas
        this.signList.checked = signDatas[0].value
        if(this.signNum === 1){
          this.$router.push({
            name: "class_student_sign_list",
            params: { classId: item.id,signPeriod: this.signList.data[0].label,status:item.status},
          })
          
        }else{
            this.data.classId = item.id
            this.data.signList = this.signList
            this.data.status = item.status
            Hub.$emit('open-modal');
            Hub.$emit('set-modal-data', this.data, '签到选择', SignSelect);
        }
      },
      // 添加编辑页面返回值
      set(value) {
          if (value === 1) {
            // 成功 页面刷新
            if (this.deleteId !== null && this.deleteId !== '' && this.deleteId !== undefined) {
              this.deleteOne()
            }
            this.doSearch(true)
          }
      },
    },
    destroyed() {
      Hub.$off('modal-confirm', this.set);
    },
    mounted() {
      this.$nextTick(function () {
        Hub.$on('modal-confirm', this.set);
      }.bind(this));
    },
  }
</script>

<style scoped>



  .search-result {
      display: block;
      position: relative;
      margin: 30px 25px 5px 25px;
  }

  .search-functions-headers {
      position: relative;
      display: flex;
      justify-content: space-between;
      top: 0;
  }
  .search-functions {
    position: relative;
    top: 0;
    display: flex;
  }

  .search-result-summary {
      display: flex;
      align-items: center;
  }

  .search-result-summary .summary {
      margin: 0 50px 0 0;
  }

  .search-result-table {
      border-spacing: 0px;
      padding-bottom: 50px;
      width: 100%;
      margin-top: 10px;
  }

  .table-header-row {
      height: 67px;
      background: #F6F6F6;
  }

  .table-header-row th {
      text-align: left;
      padding: 10px;
  }

  .table-result-row {
      height: 78px;
      font-weight: 500;
      color: #333333;
  }

  .table-result-row td {
      border-bottom: 1px solid #EBEBEB;
      padding: 10px;
      text-align: left;
  }

  .btn-detail {
      margin: 0 20px 0 20px;
      color: #0171A3;
      cursor: pointer;
  }
  .btn-signIn {
      color: #0171A3;
      cursor: pointer;
  }

  .btn-delete {
      margin: 0 20px 0 0px;
      color: #FD1F58;
      cursor: pointer;
  }
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
  
</style>
